import React from 'react'
import ReactDOM from 'react-dom'

import Component from 'components/component'

import { isServer } from 'store'

export default class FixedPanel extends Component {
  render() {
    if (isServer) {
      return null
    }
    return ReactDOM.createPortal(
      <div
        className={this.classList(
          'enterprise-fixed',
          this.props.visible && '_vis'
        )}
      >
        <div className="enterprise-fixed-inner">{this.props.children}</div>
      </div>,
      document.querySelector('#enterprise_panel_wrapper')
    )
  }
}
